// src/authConfig.js — IMA Helpdesk Portal
// App Registration: "Phishing Incident Response" — 3eea135c-b0e1-4693-8f50-cd41e6ea501b
// Tenant: The IMA Group — deb5b3ad-aea3-4155-9bdc-a24b07cb7dd4
// Portal URL: https://helpdesk.theimagroup.com (target)

export const msalConfig = {
  auth: {
    clientId: "3eea135c-b0e1-4693-8f50-cd41e6ea501b",
    authority: "https://login.microsoftonline.com/deb5b3ad-aea3-4155-9bdc-a24b07cb7dd4",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === "development") console.log(message);
      },
    },
  },
};

// All scopes for the portal — covers Response Suite + Delegation Audit
export const loginRequest = {
  scopes: [
    // Core
    "User.Read",
    // Response Suite modules
    "Mail.ReadWrite",
    "Mail.Send",
    "MailboxSettings.ReadWrite",
    "AuditLog.Read.All",
    "SecurityEvents.Read.All",
    "User.Read.All",
    "User.ReadWrite.All",
    "UserAuthenticationMethod.ReadWrite.All",
    "Directory.ReadWrite.All",
    // Device Inventory — SharePoint list read+write
    "Sites.ReadWrite.All",
  ],
};

export const GRAPH_BASE = "https://graph.microsoft.com/v1.0";
export const GRAPH_BETA  = "https://graph.microsoft.com/beta";

export const ORG_CONFIG = {
  tenantId:              "deb5b3ad-aea3-4155-9bdc-a24b07cb7dd4",
  domain:                "theimagroup.com",
  auditEmail:            "imait@theimagroup.com",
  sharepointSite:        "imagroupmgmt.sharepoint.com",
  sharepointSiteName:    "ITSec",
  sharepointListName:    "PhishingResponseAudit",
  delegationSiteId:      "imagroupmgmt.sharepoint.com,9d963613-7ac6-463a-9269-8a78c00145e6,985cd7b6-cb16-4674-9a26-04f0954a90a6",
  delegationListId:      "0e76a8fa-ec28-474f-8bc2-de9b089eae9d",
  delegationMaxHours:    24,
  delegationDefaultHours: 6,
  allowedGroupId:        null,
};
